import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { ClientOnly } from '@tanstack/react-router'

// react-apexcharts reaches for `window` at module scope, so keep it off the server.
const WaterLevelChart = lazy(() =>
  import('~/components/WaterLevelChart').then((m) => ({ default: m.WaterLevelChart })),
)

export const Route = createFileRoute('/temporary')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className=" bg-white">
      <ClientOnly fallback={null}>
        <Suspense fallback={null}>
          <WaterLevelChart title="Custom Title" predictions={[]} observations={[]} />
        </Suspense>
      </ClientOnly>
    </div>
  )
}
